export function decodeFromBinary(str: string): string {
  if (!str.length) return str;

  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}

export function encodeToBinary(str: string): string {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    })
  );
}

export function encode(value) {
  return encodeToBinary(JSON.stringify(value));
}

export function decode<T = any>(value): T {
  return JSON.parse(decodeFromBinary(value));
}
